import React, { useEffect, useState } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { useTranslation } from "react-i18next";

import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.action.hover,
    border: "1px solid rgba(0, 0, 0, 0.1)",
  },
  body: {
    fontSize: 14,
    border: "1px solid rgba(0, 0, 0, 0.1)",
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
});

const RecordTable = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { value, ...rest } = props;
  const [records, setRecords] = useState([]);

  useEffect(() => {
    if (value) {
      let valuesWithId = value.map((value, index) => {
        return { ...value, id: index + 1 };
      });
      setRecords(valuesWithId);
    }
  }, [value]);

  return (
    <>
      <Typography
        variant="button"
        style={{ textTransform: "capitalize" }}
        color="textPrimary"
      >
        {t(rest.title)}
      </Typography>
      <TableContainer component={Paper}>
        <Table className={classes.table} size="small">
          <TableHead>
            <TableRow>
              {rest.columns.map((column, index) => {
                return (
                  <StyledTableCell key={index}>{column.name}</StyledTableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {records.map((row, index) => (
              <StyledTableRow key={index}>
                <StyledTableCell>{row.id}</StyledTableCell>
                <StyledTableCell>{row.datetime}</StyledTableCell>
                <StyledTableCell>{row.name}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

RecordTable.propTypes = {
  value: PropTypes.array,
};

export default RecordTable;
